import { render, staticRenderFns } from "./ModalDeletePhoto.vue?vue&type=template&id=31df8289"
import script from "./ModalDeletePhoto.vue?vue&type=script&lang=js"
export * from "./ModalDeletePhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports